import React from 'react'
import { connect as connectRedux } from 'react-redux'
import _times from 'lodash/times'
import CloseIcon from '../Icon/icons/Close/index'
import Button, { TYPES } from '../Button/index'
import CommentsHeader from '../CommentsHeader/index'
import CommentThread from '../CommentThread/index'
import CommentsEmpty from '../CommentsEmpty/index'
import CommentPlaceholder from '../CommentPlaceholder/index'
import useComments from '../../services/comments/useComments'

function renderCommentsList (opts) {
  const {
    comments, loading, auth, createComment, updateComment, reportComment,
  } = opts
  if (loading) {
    return (
      <div className="comments__list">
        {_times(2, (i) => (
          <div key={`placeholder-${i}`} className="comment-thread comment-thread--placeholders">
            <CommentPlaceholder />
          </div>
        ))}
      </div>
    )
  }
  if (comments.length === 0) {
    return <CommentsEmpty />
  }
  return (
    <div className="comments__list">
      {comments.map((comment, index) => (
        <CommentThread
          key={`comment-${comment.id || index}`}
          comment={comment}
          auth={auth}
          createComment={createComment}
          updateComment={updateComment}
          reportComment={reportComment}
        />
      ))}
    </div>
  )
}

/**
 * @param {Object} props - The props
 * @param {String} props.title - The comments component title
 * @param {Function} props.onCloseClick - The function to call when the close button is clicked
 * @param {Map} props.detailData - The detail data
 * @param {Boolean} props.showCount - Whether to show the count of comments
 * @returns {JSX.Element} DetailPageV3Comments
 */

const DetailPageV3Comments = (props) => {
  const {
    title,
    detailData,
    auth,
    onCloseClick,
    location,
    showCount = false,
  } = props

  const contentId = detailData.get('contentId')

  const {
    comments, totalCount, loading,
    createComment, updateComment, reportComment,
  } = useComments({ contentId, auth })

  return (
    <div className="detail-page-v3__comments-container">
      <div className="detail-page-v3__comments-block-title">
        {title} {showCount && `(${totalCount})`}
      </div>
      {!!onCloseClick && <Button
          type={TYPES.LINK}
          onClick={onCloseClick}
          className="detail-page-v3__mobile-popup-close-button"
        >
          <CloseIcon color="#151515" />
        </Button>
      }
      <div className="detail-page-v3__comments">
        <div className="comments__body">
          <CommentsHeader
            auth={auth}
            data={detailData}
            location={location}
            createComment={createComment}
            updateComment={updateComment}
          />
          {renderCommentsList({
            comments, loading, auth, createComment, updateComment, reportComment,
          })}
        </div>
      </div>
    </div>
  )
}

export default connectRedux((state) => ({
  auth: state.auth,
  location: state.location,
}))(DetailPageV3Comments)
